import React from 'react';

const LegalDisclaimer = () => {
  return (
    <section className="min-h-screen bg-white text-gray p-8 py-32">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold text-center mb-6">Legal Disclaimer</h1>

        <p className="text-lg mb-6">
          The information provided on this website is for general informational purposes only. 
          All information on the site is provided in good faith, however, we make no representation or warranty of any kind, 
          express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the site.
        </p>

        <h2 className="text-2xl font-semibold mb-4">1. No Liability</h2>
        <p className="text-lg mb-6">
          By using this website, you agree that we are not responsible for any damages or losses that may occur due to the use of this website. 
          This includes, but is not limited to, any errors, omissions, interruptions, or inaccuracies that may exist in the content provided. 
          You agree to use this website at your own risk.
        </p>

        <h2 className="text-2xl font-semibold mb-4">2. External Links</h2>
        <p className="text-lg mb-6">
          Our website may contain links to third-party websites that are not operated or controlled by us. 
          We are not responsible for the content, privacy policies, or practices of any third-party websites. 
          You acknowledge and agree that we shall not be liable, directly or indirectly, for any damages or loss caused by the use of or reliance on such third-party content.
        </p>

        <h2 className="text-2xl font-semibold mb-4">3. No Legal or Financial Advice</h2>
        <p className="text-lg mb-6">
          The content on this website is not intended to be, and should not be construed as, legal, financial, or professional advice. 
          We recommend consulting with a qualified professional for advice tailored to your individual needs before making any decisions.
        </p>

        <h2 className="text-2xl font-semibold mb-4">4. Changes to the Disclaimer</h2>
        <p className="text-lg mb-6">
          We reserve the right to update or modify this legal disclaimer at any time. Any changes will be effective immediately upon posting on this page. 
          It is your responsibility to review this page regularly to stay informed about any updates.
        </p>

        <h2 className="text-2xl font-semibold mb-4">5. Indemnity</h2>
        <p className="text-lg mb-6">
          You agree to indemnify, defend, and hold harmless the website owners, operators, and affiliates from and against any claims, 
          losses, damages, liabilities, and expenses (including reasonable attorneys' fees) arising out of your use or misuse of this website, 
          your violation of these terms, or your violation of any rights of another party.
        </p>

        <h2 className="text-2xl font-semibold mb-4">6. Governing Law</h2>
        <p className="text-lg mb-6">
          This disclaimer shall be governed by and construed in accordance with the laws of your state or country, without regard to its conflict of law principles. 
          Any legal action or proceeding arising out of or related to this disclaimer or your use of the website shall be brought exclusively in the courts located within your jurisdiction.
        </p>

        <h2 className="text-2xl font-semibold mb-4">7. Contact Us</h2>
        <p className="text-lg">
          If you have any questions or concerns about this legal disclaimer, please contact us at <a href="mailto:contact@yourwebsite.com" className="text-blue-600">contact@yourwebsite.com</a>.
        </p>
      </div>
    </section>
  );
};

export default LegalDisclaimer;
